import * as S from "./style";

/**
 * Components
 */
import CreateOS from "../../../components/Modals/OS/Create";
import CreateService from "../../../components/Modals/Service/Create";
import Create from "../../../components/Modals/Supplier/Create";
import CreateUser from "../../../components/Modals/User/Create";
import ActionButton from "../../Button/ActionButton";
import InputSearch from "../../FieldSearch";
import CreateAcessory from "../../Modals/Accessory/Create";
/**
 * Hooks
 */
import { useMultipleModal } from "../../../hooks/useMultipleModal";

interface ITitle {
  title: string;
  subtitle: string;
  placeholderSearch: string;
  fetchData: () => void;
  filterSearch: (search: string) => void;
  modalKey: string;
  titleButton: string;
  visibleButton?: boolean;
}

export default function TitleDefault({
  title,
  subtitle,
  placeholderSearch,
  fetchData,
  titleButton,
  modalKey,
  filterSearch,
  visibleButton = true
}: ITitle) {
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();

  const handleInputChange = (inputSearch: string) => {
    filterSearch(inputSearch);
  };

  return (
    <S.Container>
      <S.Title>
        <S.H4>{title}</S.H4>
        <S.H6>{subtitle}</S.H6>
      </S.Title>

      <S.ContentSearch>
        <InputSearch name={placeholderSearch} onSearch={handleInputChange} />
        {
          visibleButton &&
          <ActionButton
            name={titleButton}
            onClick={() => toggleModalVisibility(modalKey)}
          />
        }
      </S.ContentSearch>

      <Create
        isOpenModal={isOpenModal("supplier")}
        setModalClose={() => toggleModalVisibility("supplier")}
        refreshFrames={fetchData}
      />

      <CreateUser
        isOpenModal={isOpenModal("user")}
        setModalClose={() => toggleModalVisibility("user")}
        refreshFrames={fetchData}
      />

      <CreateAcessory
        isOpenModalAcessory={isOpenModal("accessory")}
        setModalClose={() => toggleModalVisibility("accessory")}
        refreshFrames={fetchData}
      />

      <CreateService
        isOpenModal={isOpenModal("service")}
        setModalClose={() => toggleModalVisibility("service")}
        refreshFrames={fetchData}
      />

      <CreateOS
        isOpenModal={isOpenModal("service-order")}
        setModalClose={() => toggleModalVisibility("service-order")}
        refreshFrames={fetchData}
      />
    </S.Container>
  );
}
